import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function impactMerchantReducer(state = initialState.impactMerchantStats,action) {
  switch (action.type) {
    case types.MERCHANT_IMPACT_SUCCESS:
      return action.impactMerchantStats;
    case types.MERCHANT_IMPACT_FAILED:
      return action.error;
    default:
      return state;
  }
}
